module.exports = __webpack_public_path__ + "img/companylogo.54d8810b.png";